<div class="container">
  <h1 class="title">404</h1>
  <p class="description">Oops! The page you're looking for doesn't exist.</p>
  <a href="/" class="button">Go Home</a>
</div>
